import React from 'react';
import { Outlet } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material';
import { NetworkProvider } from '../context/NetworkContext';
import Header from './Header';
import Footer from './Footer';
import ForkAlertBanner from './ForkAlertBanner';
import CanonicalRedirect from './CanonicalRedirect';
import LiveDataNotice from './LiveDataNotice';
import usePageSeo from '../seo/usePageSeo';

const testnetTheme = createTheme({
  palette: {
    primary: {
      main: '#2e7d32',
      light: '#4caf50',
      dark: '#1b5e20',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#4caf50',
      light: '#81c784',
      dark: '#388e3c',
      contrastText: '#000000',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: { fontWeight: 700 },
    h2: { fontWeight: 600 },
    h3: { fontWeight: 600 },
    h4: { fontWeight: 600 },
    h5: { fontWeight: 500 },
    h6: { fontWeight: 500 },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          fontWeight: 500,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          boxShadow: '0 4px 8px rgba(0,0,0,0.05)',
        },
      },
    },
  },
});

const TestnetLayout = () => {
  usePageSeo();
  return (
    <NetworkProvider network="testnet">
      <ThemeProvider theme={testnetTheme}>
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
          <CanonicalRedirect />
          <Header />
          <ForkAlertBanner />
          <main style={{ flex: 1 }}>
            <Outlet />
          </main>
          <Footer />
          <LiveDataNotice />
        </div>
      </ThemeProvider>
    </NetworkProvider>
  );
};

export default TestnetLayout;
